import {useCallback, useMemo, useRef} from 'react';

const useTimer = (
    delay: number, // ms
) => {
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const clearTimeoutFunction = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }, []);
    const setTimeoutFunction = useCallback(
        (functionToTrigger: () => unknown) => {
            if (delay === 0) {
                functionToTrigger();

                return;
            }

            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(functionToTrigger, delay);
        },
        [delay, timeoutRef],
    );

    return useMemo(
        () => ({clearTimeoutFunction, setTimeoutFunction}),
        [clearTimeoutFunction, setTimeoutFunction],
    );
};

export default useTimer;
